import React, { Fragment, useEffect, useState } from "react";
import { InfoCircleTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import moment from "moment";
import {
  setTableListData,
  setTableActionDetails,
} from "../../actions/tableListing/tableListDataAction";
import { buildLogisticTableActionDetails } from "../../helper/logisticTableAction";

const LogisticTransitTab = ({
  tabTableData,
  isLoading,
  OnhandleTableSortColumn,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isO2WPage =
    window.location.pathname.split("/")[1] === "dashboard" ? true : false;

  const tableSorting = useSelector(
    (state) => state.TableSortingData.tableListData
  );

  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    if (tabTableData.logisticsIntransitTab?.length > 0) {
      setTotalRecords(tabTableData.totalRecords);
      setPageNo(Number(tabTableData.currentPage));
      dispatch(setTableListData(tabTableData.logisticsIntransitTab));
    } else {
      setTotalRecords(0);
      setPageNo(1);
    }
  }, [tabTableData.logisticsIntransitTab]);

  /// table sorting code with pagination
  const handleTableAscDes = (pagination, filters, sorter) => {
    const sortOrder = sorter.order;
    const sortField = sorter.field;
    OnhandleTableSortColumn({
      sortColumn: sortField,
      orderBy:
        sortOrder === "ascend"
          ? "asc"
          : sortOrder === "descend"
          ? "desc"
          : "asc",
      currentPage: pagination.current,
    });
  };

  /// handle overview Details page code
  const handleOverviewDetailsPage = (rowData) => {
    dispatch(setTableActionDetails(buildLogisticTableActionDetails(rowData)));
    navigate(
      `/${
        isO2WPage ? "o2w" : "logistic"
      }/overviewDetails/Intransit/${encodeURIComponent(
        rowData.customer_PO_Number
      )}`
    );
  };

  const tableColumns = [
    {
      title: "Customer Name",
      dataIndex: "customer_Organization_Name",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_Organization_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 250,
      render: (_i, row) => {
        return (
          <div>
            {row.customer_Organization_Name
              ? row.customer_Organization_Name
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Shipping Line Name",
      dataIndex: "shipping_Line_Name",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "shipping_Line_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return <div>{row.shipping_Line_Name ? row.shipping_Line_Name : "N/A"}</div>;
      },
    },
    {
      title: "SAP Order Number",
      dataIndex: "sap_Order_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "sap_Order_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return <div>{row.sap_Order_Number ? row.sap_Order_Number : "N/A"}</div>;
      },
    },
    {
      title: "Order Date",
      dataIndex: "customer_PO_Date",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_PO_Date"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 160,
      render: (_i, row) => {
        return (
          <div>
            {row.customer_PO_Date
              ? moment(row.customer_PO_Date).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Actual BL/LR Date",
      dataIndex: "actual_BL_LR_Date",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "actual_BL_LR_Date"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 160,
      render: (_i, row) => {
        return (
          <div>
            {row.actual_BL_LR_Date
              ? moment(row.actual_BL_LR_Date).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Estimate Dispatch Date",
      dataIndex: "dispatch_Estimated",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 200,
      render: (_i, row) => {
        return (
          <div>
            {row.dispatch_Estimated
              ? moment(row.dispatch_Estimated).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Actual Dispatch Date",
      dataIndex: "dispatch_Actual",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Actual"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.dispatch_Actual
              ? moment(row.dispatch_Actual).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Estimated time of arrival",
      dataIndex: "estimated_Time_Of_Arrival",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "estimated_Time_Of_Arrival"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.estimated_Time_Of_Arrival
              ? moment(row.estimated_Time_Of_Arrival).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Estimated delivery date",
      dataIndex: "dispatch_Actual",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Actual"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.dispatch_Actual
              ? moment(row.dispatch_Actual).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Truck Number",
      dataIndex: "truck_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "truck_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.truck_Number
              ? row.truck_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Container",
      dataIndex: "container",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "container"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.container
              ? row.container
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "BL/LR Number",
      dataIndex: "bL_LR_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "bL_LR_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.bL_LR_Number
              ? row.bL_LR_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Shipment Booking Date",
      dataIndex: "shipment_Booking_Date",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "shipment_Booking_Date"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.shipment_Booking_Date
              ?  moment(row.shipment_Booking_Date).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Driver Contact Number",
      dataIndex: "driver_Contact_No",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "driver_Contact_No"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.driver_Contact_No
              ? row.driver_Contact_No
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Material Number",
      dataIndex: "material_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "material_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.material_Number
              ? row.material_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Material Name",
      dataIndex: "material_Name",
      sorter: true,
      showSorterTooltip: false,
      width: 260,
      sortOrder:
        tableSorting.sortColumn === "material_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.material_Name
              ? row.material_Name
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 80,
      fixed: "right",
      render: (_i, row) => (
        <div
          className="tbl_info_details"
          onClick={() => handleOverviewDetailsPage(row)}
        >
          <InfoCircleTwoTone />
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <Table
        bordered
        scroll={{ x: 900 }}
        className="logistic_tables"
        dataSource={tabTableData.logisticsIntransitTab}
        loading={isLoading}
        onChange={handleTableAscDes}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "even-row" : "odd-row"
        }
        pagination={{
          total: totalRecords,
          pageNo: pageNo,
          pageSize: 10,
          responsive: true,
          showSizeChanger: false,
          current: pageNo,
          onChange: (pageNum) => setPageNo(pageNum),
        }}
        columns={tableColumns}
        rowStyle={(record, index) => ({
          backgroundColor: index % 2 === 0 ? "red" : "#ffffff",
        })}
      />
    </Fragment>
  );
};

export default LogisticTransitTab;
